import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { connect  } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { isRequiredSentToBell } from '../../../globals/workOrderStatus';
import { saveLocateInfo } from '../../../redux/billing/billingActions';

// material-ui imports
import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

// internal UI components
import { useWorkOrderStyles } from '../workOrderDetails'
import LocateRow from './LocateRow'
import LocateRowEdit from './LocateRowEdit';
import { useEntryStyle } from './RelatedWork';
import Button from '../../common/button/button'

const useStyles = makeStyles({
    root: {
        flexGrow: 1
    },
    card: {
        margin: '10px'
    },
    gridItem: {
        padding: '6px !important'
    },
    entryContainer: {
        marginBottom: '25px'
    },
    gridBtn: {
        textAlign: 'right'
    },
    addLocate: {
        marginBottom: '5px'
    },
    errorMsg: {
        color: 'red'
    }
});

const LocatesList = (props) => {
    const {workorderData, relatedIdInformation, edit, onClose} = props;
    const intl = useIntl();
    const classes = Object.assign(useStyles(), useWorkOrderStyles(), useEntryStyle());
    const [locateList, setLocateList] = useState([]);
    const [deletedLocateIds, setDeletedLocateIds] = useState([]);
    const [newRowCount, setNewRowCount] = useState(0);
    const [error, setError] = useState(false);
    const [requestError, setRequestError] = useState(false);
    const [locateNumberEmptyError, setLocateNumberEmptyError] = useState(false);
    const [requestAndExpireDateMisMatchError, setRequestAndExpireDateMisMatchError] = useState(false);
    const woLocateList = relatedIdInformation?.tasks?.locates?.results ? relatedIdInformation?.tasks?.locates?.results : [];

    const formatDateStamp = (params) => {
        return params ? moment.utc(params).format('MMM DD, YYYY HH:mm:ss') : ""
     } 
    // rebuild the local mutable copy of the Locate list
    useEffect(() => {
        if (woLocateList?.length > 0) {
            setLocateList(woLocateList?.map(locate => {
                return {
                    ...locate,
                    receivedDate: formatDateStamp(locate?.receivedDate),
                    requestedDate: formatDateStamp(locate?.requestedDate),
                    expirationDate: formatDateStamp(locate?.expirationDate),
        }}));
        }
    }, [woLocateList, props.lang]);

    const addLocate = () => {
        
        setLocateList([...locateList, {
            id: `new-${newRowCount}`,
            locateNumber: '',
            receivedDate: null,
            requestedDate: null,
            expirationDate: null,
            comment: '',
            new: true
        }]);

        setNewRowCount(newRowCount + 1);
        setError(false);
    }

    const removeLocate = (locate, index) => {
        
        const deletedLocate = locateList.splice(index, 1);
        if (!locate.new) {
            deletedLocateIds.push( deletedLocate[0].id )
        }
        setLocateList([...locateList]);
    }

    const cancel = () => {
        setRequestError(false)
        setLocateNumberEmptyError(false)
        setRequestAndExpireDateMisMatchError(false)
        // throw away any changes
        setLocateList(woLocateList?.map(w => Object.assign({}, w))); // Deep copy
        
        // clear list of deleted Locates
        setDeletedLocateIds([]);
        onClose()
    }
    const formateDate = (params) => {
        let iDate;
        if(params){
           iDate = moment(params).format('YYYY-MM-DD HH:mm:ss') 
        }
      return  iDate ? moment(moment(iDate)).utc().format('YYYY-MM-DD HH:mm:ss') : ""
    };
    const onSave = () => {
        setRequestError(false)
        setLocateNumberEmptyError(false)
        setRequestAndExpireDateMisMatchError(false)
        let requestDateIndicator = true
        let locateNumberIndicator = true
        let requestAndExpireDateMisMatchIndicator = true
        locateList.forEach((item)=>{
            if(!item.requestedDate) requestDateIndicator = false
            if(!item.locateNumber) locateNumberIndicator = false
            if(item.expirationDate)
                requestAndExpireDateMisMatchIndicator = moment(item.expirationDate).isBefore(moment(item.requestedDate)) ? false : true
        })
        if (requestDateIndicator && locateNumberIndicator && requestAndExpireDateMisMatchIndicator){
            var locateInfo = {
                taskId: relatedIdInformation?.tasks?.id,
                locateList: locateList
                    .filter(locate => locate.dirty)
                    .map(locate => {
                        return {
                            id: !locate.new ? locate.id : null,
                            locateNumber: locate.locateNumber,
                            receivedDate: formateDate(locate.receivedDate),
                            requestedDate: formateDate(locate.requestedDate),
                            expirationDate: formateDate(locate.expirationDate),
                            taskId: relatedIdInformation?.tasks?.id,
                            comment: locate.comment ? locate.comment : null
                        }
                    }),
                deletedLocates: deletedLocateIds,
            }

            // send the update and refresh the work order
           props.saveLocateInfo(locateInfo, workorderData?.workOrderNumber, true);

            // clear list of deleted Locates
            setDeletedLocateIds([]);

            // toggle edit mode
            onClose()

            // Clear error
            setError(false);
        }else{
            setRequestError(requestDateIndicator ? false : true)
            setLocateNumberEmptyError(locateNumberIndicator ? false : true)
            setRequestAndExpireDateMisMatchError(requestAndExpireDateMisMatchIndicator ? false : true)
        }
    }
    return (
        <Grid container className={classes.root}>
            {error && <div className={classes.errorMsg}>
                        <FormattedMessage
                            id='admin.work-order-details.locate-list.locates-required-error-msg'
                            defaultMessage='At least 1 locate is mandatory for related work locates submission'
                            description='Admin work order locate list locates mandatory error message'
                        />
                    </div>
            }

            {
                locateList.map((locate, i) => {
                    if (edit)
                        return <LocateRowEdit locate={locate} key={locate.id} removeLocate={() => removeLocate(locate, i)} />
                    return <LocateRow locate={locate} key={locate.id} />
                })
            }

            <div>
                {requestError && <div className={classes.errorMsg}>
                    <FormattedMessage
                        id='admin.work-order-details.locate-list.locates-required-request-date-error-msg'
                        defaultMessage='Request date is mandatory for related work locates entry'
                        description='Request date is mandatory for related work locates entry'
                    />
                </div>}
                {locateNumberEmptyError && <div className={classes.errorMsg}>
                    <FormattedMessage
                        id='admin.work-order-details.locate-list.locates-number-empty-error-msg'
                        defaultMessage='Locate number is mandatory for related work locates entry'
                        description='Locate number is mandatory for related work locates entry'
                    />
                </div>
                }
                {requestAndExpireDateMisMatchError && <div className={classes.errorMsg}>
                    <FormattedMessage
                        id='admin.work-order-details.locate-list.locates-requestDate-expireDate-mismatch-error-msg'
                        defaultMessage='Expire date need to be after request date for related work locates entry'
                        description='Expire date need to be after request date for related work locates entry'
                    />
                </div>
                }
            </div>

            {edit &&
                <Grid item xs={12} className={classes.entryContainer} >
                    <Grid container spacing={1}>
                        <Grid item lg={8} md={6} xs={6} />
                        <Grid item lg={4} md={6} xs={6} className={classes.gridBtn}>
                            <Button tertiary onClick={() => cancel()}>
                                <FormattedMessage
                                    id='admin.work-order-details.locate-list.cancel-locate-edit-button-caption'
                                    defaultMessage='Cancel'
                                    description='Admin work order locate list cancel locate edit button caption'
                                />
                            </Button>
                            <Button secondary onClick={() => onSave()}>
                                <FormattedMessage
                                    id='admin.work-order-details.locate-list.save-locate-edit-button-caption'
                                    defaultMessage='Save changes'
                                    description='Admin work order locate list save locate edit button caption'
                                />
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} className={classes.addLocate}>
                            <Button secondary onClick={() => addLocate()}>
                                <FormattedMessage
                                    id='admin.work-order-details.locate-list.add-locate-button-caption'
                                    defaultMessage='Add locate + '
                                    description='Admin work order locate list Add locate button caption'
                                />
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}


const mapStateToProps = (state) => ({
    lang: state.domain.locale.lang
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    saveLocateInfo
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(LocatesList);